import * as React from 'react'

function RedDot(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={6} height={6} viewBox="0 0 6 6" {...props}>
      <rect data-name="Rectangle 7671" width={6} height={6} rx={3} fill="#fe5f55" />
    </svg>
  )
}

export default RedDot
